<template>
  <div >
    {{msg}}
    <div class="container">
      <div class="de">
        <div class="den">
          <div class="dene">
            <div class="denem">
              <div class="deneme">
                12<span
                  >.0</span><strong>&deg;</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {

  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted(){
    console.log(this.msg)
    let user = firebase.auth().currentUser;
    if (user != null){
      console.log(user.displayName)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html {
    min-height: 100% !important;
  }

  body {
    background: #505050 -moz-radial-gradient(top, #cdcdcf 0%, #505050 70%) no-repeat 50% 0%;
    background: #505050 radial-gradient(top, #cdcdcf 0%, #505050 70%) no-repeat 50% 0%;
    height: 100%;
  }
  .imgchart{
    position:absolute;
    width: 25px;
    top:30px;
    right: 30px;

  }
  .title {
    top: 44%;
    width: 100%;
    position: relative;
    left: 0;
    right: 0;
    margin: 10px auto 15px;
  }

  @import url(https://fonts.googleapis.com/css?family=Dosis:200,400,500,600);

  html,
  body {
    height: 100%;
  }

  body {
    background: #f2f2f2;
  }

  .container {
    width: 230px;
    margin: 20px auto 0;
  }

  .de .den,
  .de .dene,
  .de .denem,
  .de .deneme {
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .de {
    position: relative;
    width: 240px;
    height: 240px;
    border-radius: 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    background-color: transparent;
  }

  .den {
    position: relative;
    width: 210px;
    height: 210px;
    margin: -105px 0 0 -105px;
    border-radius: 100%;
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, .5), 0 2px 20px rgba(255, 255, 255, 1);
    background: #df3341;
    background: -moz-linear-gradient(left, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    background: -webkit-gradient(linear, left top, right top, color-stop(0%, #df3341), color-stop(50%, #d4f355), color-stop(100%, #61c0ec));
    background: -webkit-linear-gradient(left, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    background: linear-gradient(to right, #df3341 0%, #d4f355 50%, #61c0ec 100%);
    position: relative;
  }

  .dene {
    width: 180px;
    height: 180px;
    margin: -90px 0 0 -90px;
    border-radius: 100%;
    box-shadow: inset 0 2px 2px rgba(255, 255, 255, .4), 0 3px 13px rgba(0, 0, 0, .85);
    background: #f2f6f5;
    background: -moz-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #f2f6f5), color-stop(100%, #cbd5d6));
    background: -webkit-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
    background: -o-linear-gradient(top, #f2f6f5 0%, #cbd5d6 100%);
  }

  .denem {
    width: 160px;
    height: 160px;
    margin: -80px 0 0 -80px;
    border-radius: 100%;
    background: #cbd5d6;
    background: -moz-linear-gradient(top, #cbd5d6 0%, #f2f6f5 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #cbd5d6), color-stop(100%, #f2f6f5));
    background: -webkit-linear-gradient(top, #cbd5d6 0%, #f2f6f5 100%);
  }

  .deneme {
    padding: 3px 10px 0 10px;
    width: 120px;
    height: 137px;
    display: inline-block;
    margin: -70px 0 0 -70px;
    color: #555;
    text-shadow: 1px 1px 1px white;
    font-family: 'Dosis';
    font-size: 100px;
    font-weight: 400;
    text-align: center;
  }

  .deneme span {
    font-size: 30px;
    font-weight: 200;
  }

  .deneme strong {
    position: absolute;
    right: 10px;
    top: 25px;
    font-size: 34px;
  }
</style>